import { Dispatch } from "@reduxjs/toolkit";
import { setBMSR, toggleRider } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";
import { addAmountOfLoansRider, updateAmountOfLoansRiderFAmount } from "../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice";
import { Riders } from "../../api/gms/proposal/proposal-api-state";
import { pa_addAmountOfLoansRider, pa_setBMSR, pa_toggleRider, pa_updateAmountOfLoansRiderFAmount } from "../../features/propose-data/propose-data-slice";

export const populateRidersAmountOfLoans = (
    dispatch: Dispatch, 
    coverageLabel: string | undefined, 
    riders: Riders[], 
    type: "current" | "proposed",
    optionForGroupDengueRider?: { id: number; fAmount: number; label: string }[]
) => {
    riders.forEach((rider) => {
        const riderData = { id: rider.rider_id, label: rider.rider_name };

        if (type === "current") {
            dispatch(toggleRider(riderData));
        }
        // if (type === "proposed") {
        //     dispatch(pa_toggleRider(riderData));
        // }
    });

    riders.forEach((rider) => {
        const riderData = { 
            id: rider.rider_id, 
            label: rider.rider_name 
        };

        if (type === "current") {
            dispatch(addAmountOfLoansRider(riderData));
            dispatch(updateAmountOfLoansRiderFAmount({ 
                riderId: rider.rider_id, 
                fAmount: rider.amount ?? 0
            }));
        }

        if (type === "proposed") {
            dispatch(pa_addAmountOfLoansRider(riderData));
            dispatch(pa_updateAmountOfLoansRiderFAmount({ 
                riderId: rider.rider_id, 
                fAmount: rider.amount ?? 0 
            }));
        }
    });

    const riderMap: Record<string, number[]> = {
        BMSR: [
            PROPOSAL_RIDERS.BMSR.productFor.GYRT,
            PROPOSAL_RIDERS.BMSR.productFor.GCI,
        ],
    };

    const riderBMSR = riders.find((rider) => riderMap.BMSR.includes(rider.rider_id));

    const bmsrData = {
        id: riderBMSR?.rider_id ?? 0,
        label: riderBMSR?.rider_name ?? "",
        inputs: [{ fAmount: riderBMSR?.amount ?? 0 }],
    };

    if (type === "current") {
        dispatch(setBMSR(bmsrData));
    }
    if (type === "proposed") {
        dispatch(pa_setBMSR(bmsrData));
    }
};